import { z } from 'zod';
import type { $brand } from 'zod/v4/core';

export type ClientId = string & $brand<'ClientId'>;
export const clientIdSchema = z.uuid().transform((id) => id as ClientId);

export type PersonId = string & $brand<'PersonId'>;
export const personIdSchema = z.uuid().transform((id) => id as PersonId);
